import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import apiUrl from "../../environment/Api";
import { useNavigate, useParams } from "react-router-dom";
import "../../assets/css/Invoicemanagement.css"; // Use the same CSS as Addinvoice
import { toast } from "react-toastify";

function Updateinvoice() {
  const { id } = useParams();

  const [fetchupdatedata, setfetchupdatedata] = useState([]);
  const [currentDate, setCurrentDate] = useState("");
  const [responseDatas, setResponseDatas] = useState([]);
  const [responsePayment, setResponsePayment] = useState([]);

  const [selectDataEmail, setSelectDataEmail] = useState("");
  const [selectDataMobile, setSelectDataMobile] = useState("");
  const [selectDataName, setSelectDataName] = useState("");
  const [selectidName, setSelectidName] = useState("");

  const [responseDatased, setResponseDatased] = useState([]);
  const [paymenttype, setpaymenttype] = useState([]);
  const [paymenthistroy, setpaymenthistroy] = useState([]);
  const [invoicelist, setinvoicelist] = useState([]);
  const [isUpdateshowModal, setUpdateShowModal] = useState(false);
  const [selectedbranch, setselectedbranch] = useState({
    branch_id: "",
    branch_name: "",
  });

  const [updatedata, setupdatedata] = useState({
    invoice_no: "",
    date: "",
    type: "",
    dependent: "",
    name: "",
    email: "",
    mobile_no: "",
    fees: "",
    course_id: "",
    paid_Date: "",
    paid_till_date: "",
    payment_due_date: "",
    next_due_date: "",
    person_name: "",
    contact: "",
  });

  const [paymentupdate, setpaymentupdate] = useState({
    branch_id: "",
    invoice_no: "",
    date: "",
    dependent: "",
    paytype: "",
    paid_by: "",
    paid: "",
    course_id: "",
    studyingstudent: "",
  });

  const navigate = useNavigate();

  const handleNewButtonClick = async () => {
    await handleSavePayment();
    navigate(`/Studentinvoice/${fetchupdatedata.invoice_no}`);
  };

  const handleclose = async () => {
    navigate(`/invoice`);
  };

  const handleclear = () => {
    setupdatedata({
      invoice_no: "",
      date: "",
      type: "",
      dependent: "",
      name: "",
      email: "",
      mobile_no: "",
      branch_id: "",
      paid_till_date: "",
      payment_due_date: "",
      next_due_date: "",
      person_name: "",
      contact: "",
    });
  };

  useEffect(() => {
    const fetchD = async () => {
      try {
        const response = await axios.get(apiUrl + `/invoice_details/${id}`);
        console.log("Response from server generate:", response.data);
        const fetch = response.data.studyingstudent;
        const invoicelist = response.data.studyingstudent;
        setfetchupdatedata(response.data);

        updatedata.invoice_no = response.data.invoice_no;
        if (response.status === 200) {
          try {
            const response = await axios.get(
              apiUrl + `/paymenthistroy/${fetch}`
            );
            console.log("Response from server paymenthistroy:", response.data);
            setpaymenthistroy(response.data);
          } catch (error) {
            console.error("Error fetching data:", error.message);
          }
        }
        if (response.status === 200) {
          try {
            const response = await axios.get(
              apiUrl + `/invoice_list/${invoicelist}`
            );
            console.log("Response from server invoice_list:", response.data);
            setinvoicelist(response.data);
          } catch (error) {
            console.error("Error fetching data:", error.message);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };

    fetchD();
  }, []);

  useEffect(() => {
    const fetchDatased = async () => {
      try {
        const response = await axios.get(apiUrl + "/Branch");
        console.log("Response from server brach :", response.data);
        setResponseDatased(response.data);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };

    fetchDatased();
  }, []);

  useEffect(() => {
    const paymenttyperoute = async () => {
      try {
        const response = await axios.get(apiUrl + "/paytype");
        console.log("Response from server:", response.data);
        setpaymenttype(response.data);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };
    paymenttyperoute();
  }, []);

  useEffect(() => {
    const fetchDatas = async () => {
      try {
        const response = await axios.get(apiUrl + "/student");
        const responsePayment = await axios.get(apiUrl + "/paymenthistroy");
        console.log("Response from server type student:", response.data);
        console.log(
          "Response from server type responsePayment:",
          responsePayment.data
        );
        setResponseDatas(response.data);
        setResponsePayment(responsePayment.data);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };
    fetchDatas();
  }, []);

  const [updateid, setUpdateId] = useState("");

  const handleUpdate = (_id, data) => {
    setUpdateId(_id);
    console.log(" the data to updata", data);
    setUpdateShowModal(true);
    setpaymentupdate({
      branch_id: data.branch_id,
      invoice_no: data.invoice_no,
      date: data.date,
      dependent: data.dependent,
      paytype: data.paytype,
      paid_by: data.paid_by,
      paid: data.paid,
      course_id: data.course_id,
      studyingstudent: data.studyingstudent,
    });
  };

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = {
        branch_id: paymentupdate.branch_id,
        invoice_no: paymentupdate.invoice_no,
        date: paymentupdate.date,
        dependent: paymentupdate.dependent,
        paytype: paymentupdate.paytype,
        paid_by: paymentupdate.paid_by,
        paid: paymentupdate.paid,
        course_id: paymentupdate.course_id,
        studyingstudent: paymentupdate.studyingstudent,
      };
      console.log("the update submit data", formData);
      const response = await axios.put(
        apiUrl + `/paymenthistroy/${updateid}`,
        formData
      );
      console.log("response for update", response);
      setUpdateShowModal(false);
      toast.success("Update successfully!");
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const formatDatefitch = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0];
  };

  const handlePaidByChange = (e) => {
    const datapaid = e.target.value;
    setfetchupdatedata((prevData) => ({
      ...prevData,
      paid_by: datapaid,
    }));
  };

  const handlePaidChange = (e) => {
    const datapaid = e.target.value;
    setfetchupdatedata((prevData) => ({
      ...prevData,
      paid: datapaid,
    }));
  };

  const handleDateChanged = (event) => {
    const selectedDate = event.target.value;
    setfetchupdatedata({
      ...fetchupdatedata,
      paid_Date: selectedDate,
    });
  };

  const handleAddPayment = () => {
    console.log(paymenthistroy, "paymenthistroy");
    console.log(fetchupdatedata, "fetchupdatedata");

    if (!fetchupdatedata || !paymenthistroy) {
      console.error("Error: fetchupdatedata or paymenthistroy is undefined!");
      return;
    }

    setpaymenthistroy((prevState) => [
      ...prevState,
      {
        branch_id: fetchupdatedata.branch_id,
        course_id: fetchupdatedata.course_id,
        date: fetchupdatedata.date,
        dependent: fetchupdatedata.dependent,
        details: fetchupdatedata.dependent,
        invoice_no: fetchupdatedata.invoice_no,
        paid: fetchupdatedata.paid,
        paid_by: fetchupdatedata.paid_by || "Unknown",
        paytype: fetchupdatedata.paytype,
        studyingstudent: fetchupdatedata.studyingstudent,
      },
    ]);

    console.log("this is my calcilate ", fetchupdatedata.paid);
    console.log("this is my calcilate ", fetchupdatedata.balance);
    console.log("this is my calcilate 123", paymenthistroy);

    const newcalculatpaid = fetchupdatedata.balance - fetchupdatedata.paid;
    console.log("this is my calcilate ", newcalculatpaid);

    setfetchupdatedata((prevData) => ({
      ...prevData,
      balance: newcalculatpaid,
    }));
  };

  useEffect(() => {
    const totalAmountValue = paymenthistroy.reduce((total, item) => {
      return total + Number(item.paid);
    }, 0);

    setupdatedata({ ...updatedata, paid_till_date: totalAmountValue });
  }, [paymenthistroy]);

  const [totalpaidamo, settotalpaidamo] = useState("");

  const consoledata = () => {
    console.log("this is my calcilate 123", paymenthistroy);

    const totalAmountValue = paymenthistroy.reduce((total, item) => {
      return total + (Number(item.paid) || 0);
    }, 0);

    console.log("this is my calcilate total:", totalAmountValue);
    settotalpaidamo(totalAmountValue);
  };

  useEffect(() => {
    consoledata();
  }, [paymenthistroy]);

  const handleSavePayment = async () => {
    const formdata = {
      branch_id: fetchupdatedata.branch_id,
      branch_name: fetchupdatedata.branch_name,
      invoice_no: fetchupdatedata.invoice_no,
      date: fetchupdatedata.date,
      type: fetchupdatedata.type,
      dependent: fetchupdatedata.dependent,
      name: fetchupdatedata.name,
      email: fetchupdatedata.email,
      mobile: fetchupdatedata.mobile,
      subtotal: fetchupdatedata.subtotal,
      gst: fetchupdatedata.gst,
      discount: fetchupdatedata.discount,
      nettotal: fetchupdatedata.nettotal,
      paytype: fetchupdatedata.paytype,
      paid: totalpaidamo,
      paid_Date: fetchupdatedata.paid_Date,
      paid_by: fetchupdatedata.setpaid_by,
      balance: fetchupdatedata.balance,
      course_id: fetchupdatedata.course_id,
      notes: fetchupdatedata.notes,
      paid_till_date: fetchupdatedata.paid_till_date,
      payment_due_date: fetchupdatedata.payment_due_date,
      next_due_date: fetchupdatedata.next_due_date,
      person_name: fetchupdatedata.person_name,
      contact: fetchupdatedata.contact,
      studyingstudent: fetchupdatedata.studyingstudent,
    };
    console.log("update data", formdata);

    try {
      const response = await axios.put(
        `${apiUrl}/invoice_details/${id}`,
        formdata
      );

      console.log("the response data was", response.data.next_due_date);

      if (response) {
        if (response.status === 200) {
          navigate(`/invoice`);

          const formdata = invoicelist.map((data) => ({
            invoice_no: data.invoice_no,
            branch_id: data.branch_id,
            description: data.description,
            qty: data.qty,
            price: data.price,
            total: data.total,
            studyingstudent: data.studyingstudent,
            course_id: data.course_id,
          }));

          try {
            const response = await axios.post(
              `${apiUrl}/invoice_list`,
              formdata
            );
            console.log("invoice list submit", response.data);

            if (response.status === 200) {
              const formDatas = {
                branch_id: fetchupdatedata.branch_id,
                invoice_no: fetchupdatedata.invoice_no,
                date: fetchupdatedata.date,
                dependent: fetchupdatedata.dependent,
                paytype: fetchupdatedata.paytype,
                paid_by: fetchupdatedata.paid_by,
                paid: fetchupdatedata.paid,
                course_id: fetchupdatedata.course_id,
                studyingstudent: fetchupdatedata.studyingstudent,
              };
            }
          } catch (error) {
            console.error("Error fetching data:", error.message);
          }

          try {
            const formDatas = {
              branch_id: fetchupdatedata.branch_id,
              invoice_no: fetchupdatedata.invoice_no,
              date: fetchupdatedata.date,
              dependent: fetchupdatedata.dependent,
              paytype: fetchupdatedata.paytype,
              paid_by: fetchupdatedata.paid_by,
              paid: fetchupdatedata.paid,
              course_id: fetchupdatedata.course_id,
              studyingstudent: fetchupdatedata.studyingstudent,
            };
            console.log("invoice paymenthistroy formDatas", formDatas);
            const response = await axios.post(
              `${apiUrl}/paymenthistroy`,
              paymenthistroy
            );

            console.log("invoice paymenthistroy", response.data);
          } catch (error) {
            console.error("Error fetching data:", error.message);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const handlePaytypeChange = (e) => {
    const datapaid = e.target.value;
    setfetchupdatedata((prevData) => ({
      ...prevData,
      paytype: datapaid,
    }));
  };

  const personname = (e) => {
    const dataperson = e.target.value;
    setfetchupdatedata((prevData) => ({
      ...prevData,
      person_name: dataperson,
    }));
  };

  const paidtilldate = (e) => {
    const dataperson = e.target.value;
    setfetchupdatedata((prevData) => ({
      ...prevData,
      paid_till_date: dataperson,
    }));
  };

  const contactdata = (e) => {
    const datacontact = e.target.value;
    setfetchupdatedata((prevData) => ({
      ...prevData,
      contact: datacontact,
    }));
  };

  const formatDateForInput = (dateString) => {
    return new Date(dateString).toISOString().split("T")[0];
  };

  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleDateChange = (event) => {
    const newDate = event.target.value;
    const updatedDate = new Date(newDate + "T00:00:00.000Z").toISOString();

    setfetchupdatedata((prevData) => ({
      ...prevData,
      next_due_date: updatedDate,
    }));
  };

  const handleDatepayment = (event) => {
    const newDate = event.target.value;
    const updatedDate = new Date(newDate + "T00:00:00.000Z").toISOString();

    setfetchupdatedata((prevData) => ({
      ...prevData,
      payment_due_date: updatedDate,
    }));
  };

  const branch_name = localStorage.getItem("branch_name");
  const isDisabled = branch_name !== "Branches";

  return (
    <div className="invoice-management-wrapper">
      {/* Header */}
      <div className="invoice-header">
        <h5>Update Invoice</h5>
      </div>

      {/* Row 1: Invoice No and Date */}
      <div className="invoice-card">
        <div className="invoice-row">
          <div style={{ flex: "0 0 140px" }}>
            <label>Invoice No</label>
            <input
              type="text"
              value={fetchupdatedata.invoice_no}
              onChange={(e) =>
                setupdatedata({ ...updatedata, invoice_no: e.target.value })
              }
              disabled
            />
          </div>
          <div style={{ flex: "0 0 140px" }}>
            <label>Date</label>
            <input
              type="date"
              value={
                fetchupdatedata.date
                  ? new Date(fetchupdatedata.date).toISOString().split("T")[0]
                  : ""
              }
              readOnly
              disabled
            />
          </div>

          {/* Row 2: Name, Email, Mobile */}
          <div>
            <label>Student Name</label>
            <input
              type="text"
              value={fetchupdatedata.name}
              disabled
            />
          </div>
          <div>
            <label>Email</label>
            <input
              type="text"
              value={fetchupdatedata.email}
              disabled
            />
          </div>
          <div style={{ flex: "0 0 140px" }}>
            <label>Mobile</label>
            <input
              type="tel"
              value={fetchupdatedata.mobile}
              disabled
            />
          </div>
        </div>
      </div>

      {/* Row 3: Course, Branch, Type */}
      <div className="invoice-card">
        <div className="invoice-row">
          <div>
            <label>Course</label>
            <input
              type="text"
              value={fetchupdatedata.dependent}
              disabled
            />
          </div>
          <div>
            <label>Branch</label>
            <select
              value={fetchupdatedata.branch_id}
              required
              disabled
            >
              <option value="">Select Branch</option>
              {responseDatased.map((item, index) => (
                <option key={index} value={item.branch_id}>
                  {`${item.branch_id}-${item.branch_name}`}
                </option>
              ))}
            </select>
          </div>
          <div style={{ flex: "0 0 100px" }}>
            <label>Type</label>
            <select
              value={fetchupdatedata.type}
              disabled
            >
              <option value="">Select Type</option>
              <option value="course">Course</option>
            </select>
          </div>

          {/* Row 4: Paid Till, Next Due, Person, Contact */}
          <div style={{ flex: "0 0 140px" }}>
            <label>Paid Till</label>
            <input
              type="text"
              value={fetchupdatedata.paid_till_date}
              onChange={paidtilldate}
              disabled={isDisabled}
            />
          </div>
          <div style={{ flex: "0 0 140px" }}>
            <label>Next Due</label>
            <input
              type="date"
              value={
                fetchupdatedata.next_due_date
                  ? formatDateForInput(fetchupdatedata.next_due_date)
                  : ""
              }
              onChange={handleDateChange}
              disabled={isDisabled}
            />
          </div>
          <div>
            <label>Person</label>
            <input
              type="text"
              value={fetchupdatedata.person_name}
              onChange={personname}
              disabled={isDisabled}
            />
          </div>
          <div style={{ flex: "0 0 140px" }}>
            <label>Contact</label>
            <input
              type="number"
              value={fetchupdatedata.contact}
              onChange={contactdata}
              disabled={isDisabled}
            />
          </div>
        </div>
      </div>

      {/* Invoice Items and Calculation Panel */}
      <div className="invoice-items-container">
        {/* Left Side: Invoice Items + Payment History */}
        <div className="left-tables-wrapper">
          {/* Invoice Items Table */}
          <div className="invoice-items-table">
            <h5>Invoice Items</h5>
            <div className="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th style={{ width: "35px" }}>S.No</th>
                    <th>Description</th>
                    <th style={{ width: "80px" }}>Qty</th>
                    <th style={{ width: "100px" }}>Fees</th>
                    <th style={{ width: "100px" }}>Total</th>
                    <th style={{ width: "50px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {invoicelist.map((data, index) => (
                    <tr key={data.invoicelist}>
                      <td>{index + 1}</td>
                      <td>
                        <input
                          type="text"
                          value={data.description}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={data.qty}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={data.price}
                          inputMode="numeric"
                          style={{
                            "-webkit-appearance": "none",
                            "-moz-appearance": "textfield",
                            appearance: "textfield",
                            margin: 0,
                          }}
                          onWheel={(e) => e.preventDefault()}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={data.total}
                          readOnly
                        />
                      </td>
                      <td>
                        <i
                          className="fa-sharp-duotone fa-solid fa-circle-xmark delete-icon"
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Payment History Table */}
          <div className="payment-history-table">
            <h5>Payment History</h5>
            <div className="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th style={{ width: "35px" }}>No</th>
                    <th style={{ width: "80px" }}>Branch</th>
                    <th>Details</th>
                    <th style={{ width: "90px" }}>Date</th>
                    <th style={{ width: "70px" }}>Paid</th>
                    <th style={{ width: "70px" }}>Type</th>
                    <th style={{ width: "70px" }}>By</th>
                    <th style={{ width: "70px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paymenthistroy.map((payment, index) => (
                    <tr key={payment.id}>
                      <td>{index + 1}</td>
                      <td>{payment.branch_id}</td>
                      <td>{payment.details}</td>
                      <td>{formatDatefitch(payment.date)}</td>
                      <td>₹{payment.paid}</td>
                      <td>{payment.paytype}</td>
                      <td>{payment.paid_by}</td>
                      <td>
                        <button
                          className="btn btn-danger m-2"
                          style={{ padding: "0.2rem 0.5rem", fontSize: "0.8rem" }}
                        >
                          <i className="fa-solid fa-xmark"></i>
                        </button>
                        <button
                          className="btn updeletedinvoice"
                          onClick={() =>
                            handleUpdate(payment._id, payment)
                          }
                          style={{ padding: "0.2rem 0.5rem", fontSize: "0.8rem" }}
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Calculation Panel - Right Side */}
        <div className="calculation-panel">
          <div className="calc-row">
            <span className="calc-label">Subtotal</span>
            <input
              type="number"
              className="calc-input"
              value={fetchupdatedata.subtotal}
              disabled
            />
          </div>

          <div className="calc-row">
            <span className="calc-label">GST</span>
            <input
              type="number"
              className="calc-input"
              value={fetchupdatedata.gst}
              disabled
              placeholder="0%"
            />
          </div>

          <div className="calc-row">
            <span className="calc-label">Discount (%)</span>
            <input
              type="number"
              className="calc-input"
              value={fetchupdatedata.discount}
              disabled
              placeholder="0%"
            />
          </div>

          <div className="calc-row">
            <span className="calc-label">Net Total</span>
            <input
              type="number"
              className="calc-input"
              value={fetchupdatedata.nettotal}
              disabled
            />
          </div>

          <div className="calc-row">
            <span className="calc-label">Pay Type</span>
            <select
              className="calc-input"
              value={fetchupdatedata.paytype}
              onChange={handlePaytypeChange}
            >
              <option value="">Select</option>
              {paymenttype.map((item, index) => (
                <option key={index} value={item.Payment_type}>
                  {item.Payment_type}
                </option>
              ))}
            </select>
          </div>

          <div className="calc-row">
            <span className="calc-label">Paid By</span>
            <select
              className="calc-input"
              value={fetchupdatedata.paid_by}
              onChange={handlePaidByChange}
            >
              <option value="">Select</option>
              <option value="Parent">Parent</option>
              <option value="Student">Student</option>
              <option value="Gradian">Guardian</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="calc-row">
            <span className="calc-label">Paid Amt</span>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.3rem", width: "140px" }}>
              <input
                type="number"
                value={fetchupdatedata.paid}
                onChange={handlePaidChange}
                placeholder="0.00"
              />
              <button
                className="btn-primary"
                onClick={handleAddPayment}
                style={{ fontSize: "0.7rem", padding: "0.3rem" }}
              >
                Add
              </button>
            </div>
          </div>

          <div className="calc-row">
            <span className="calc-label">Paid Date</span>
            <input
              type="date"
              className="calc-input"
              value={
                fetchupdatedata.paid_Date
                  ? new Date(fetchupdatedata.paid_Date)
                      .toISOString()
                      .split("T")[0]
                  : ""
              }
              onChange={handleDateChanged}
            />
          </div>

          <div className="calc-row">
            <span className="calc-label">Balance</span>
            <input
              type="number"
              className="calc-input"
              value={fetchupdatedata.balance}
            />
          </div>

          {/* Action Buttons */}
          <div className="button-group">
            <button type="button" className="btn-danger" onClick={handleclose}>
              Close
            </button>
            <button type="button" className="btn-info" onClick={handleclear}>
              Clear
            </button>
            <button type="button" className="btn-secondary" onClick={handleSavePayment}>
              Save
            </button>
            <button type="button" className="btn-success" onClick={handleNewButtonClick}>
              Print
            </button>
          </div>
        </div>
      </div>

      {/* Update Modal */}
      <Modal
        show={isUpdateshowModal}
        onHide={() => setUpdateShowModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="modeti">Update Payment History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <div className="floating-label">
              <input
                className="form-control"
                type="text"
                placeholder=""
                value={paymentupdate.branch_id}
                onChange={(e) =>
                  setpaymentupdate({
                    ...paymentupdate,
                    branch_id: e.target.value,
                  })
                }
                required
              />
              <label className={paymentupdate.branch_id ? "filled" : ""}>
                Branch Code
              </label>
            </div>

            <div className="floating-label">
              <input
                className="form-control"
                type="text"
                placeholder=""
                value={paymentupdate.invoice_no}
                onChange={(e) =>
                  setpaymentupdate({
                    ...paymentupdate,
                    invoice_no: e.target.value,
                  })
                }
                required
              />
              <label className={paymentupdate.invoice_no ? "filled" : ""}>
                Invoice No
              </label>
            </div>

            <div className="floating-label">
              <input
                className="form-control"
                type="date"
                placeholder=""
                value={
                  paymentupdate.date ? paymentupdate.date.split("T")[0] : ""
                }
                onChange={(e) =>
                  setpaymentupdate({ ...paymentupdate, date: e.target.value })
                }
                required
              />
              <label className={paymentupdate.date ? "filled" : ""}>
                Date
              </label>
            </div>
            <div className="floating-label">
              <input
                className="form-control"
                type="tel"
                placeholder=""
                value={paymentupdate.dependent}
                onChange={(e) =>
                  setpaymentupdate({
                    ...paymentupdate,
                    dependent: e.target.value,
                  })
                }
                required
              />
              <label className={paymentupdate.dependent ? "filled" : ""}>
                Dependent
              </label>
            </div>

            <div className="floating-label">
              <select
                className="form-control "
                value={paymentupdate.paytype}
                onChange={(e) =>
                  setpaymentupdate({
                    ...paymentupdate,
                    paytype: e.target.value,
                  })
                }
              >
                <option value="">Select Paytype</option>
                {paymenttype.map((item, index) => (
                  <option key={index} value={item.Payment_type}>
                    {item.Payment_type}
                  </option>
                ))}
              </select>
            </div>

            <div className="floating-label">
              <input
                className="form-control"
                type="email"
                placeholder=""
                value={paymentupdate.paid_by}
                onChange={(e) =>
                  setpaymentupdate({
                    ...paymentupdate,
                    paid_by: e.target.value,
                  })
                }
                required
              />
              <label className={paymentupdate.paid_by ? "filled" : ""}>
                Paid By
              </label>
            </div>

            <div className="floating-label">
              <input
                className="form-control"
                type="email"
                placeholder=""
                value={paymentupdate.paid}
                onChange={(e) =>
                  setpaymentupdate({ ...paymentupdate, paid: e.target.value })
                }
                required
              />
              <label className={paymentupdate.paid ? "filled" : ""}>
                Paid
              </label>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="cancelbut"
            variant="secondary"
            onClick={() => setUpdateShowModal(false)}
          >
            Cancel
          </Button>
          <Button
            className="submitbut"
            variant="primary"
            onClick={handleupdatesubmit}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Updateinvoice;